import { render, staticRenderFns } from "./TextFontBoxTool.vue?vue&type=template&id=6a53208a&scoped=true&"
import script from "./TextFontBoxTool.vue?vue&type=script&lang=js&"
export * from "./TextFontBoxTool.vue?vue&type=script&lang=js&"
import style0 from "./TextFontBoxTool.vue?vue&type=style&index=0&id=6a53208a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a53208a",
  null
  
)

export default component.exports